{
  "familyId": "GET-PROC-TERUG",
  "questions": [
    {
      "id": "GET-PROC-TERUG-001",
      "familyId": "GET-PROC-TERUG",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_terugrekenen",
      "questionType": "multiple_choice",
      "question": "30% van een bedrag is €60. Wat is het hele bedrag (100%)?",
      "context": null,
      "options": ["€200", "€180", "€90", "€18"],
      "correctAnswer": 0,
      "conceptId": "reverse_percent_basic",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen met procenten",
            "content": "1%-methode: als p% = x, dan is 1% = x ÷ p, en 100% = (x ÷ p) × 100. Of direct: 100% = x ÷ (p/100) = x × (100/p)."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is €200. Terugrekenen: als 30% = €60, dan is 1% = €60 ÷ 30 = €2. Dan is 100% = €2 × 100 = €200. Of direct: €60 ÷ 0,30 = €200.",
        "distractorExplanations": {
          "0": "Goed! 1% = €60 ÷ 30 = €2. Dan 100% = €2 × 100 = €200.",
          "1": "€180 is fout. Je hebt misschien €60 × 3 = €180 berekend (30% × 3 = 90%, niet 100%). Gebruik de 1%-methode: 1% = €60 ÷ 30 = €2, dan 100% = €2 × 100 = €200.",
          "2": "€90 is fout. Je hebt misschien €60 + 30 = €90 berekend (opgeteld in plaats van gedeeld). Gebruik de 1%-methode: 1% = €60 ÷ 30 = €2, dan 100% = €200.",
          "3": "€18 is fout. Je hebt misschien €60 × 0,30 = €18 berekend (procent van het deel, niet het geheel). Gebruik de 1%-methode: 1% = €60 ÷ 30 = €2, dan 100% = €200."
        }
      }
    },
    {
      "id": "GET-PROC-TERUG-002",
      "familyId": "GET-PROC-TERUG",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_terugrekenen",
      "questionType": "multiple_choice",
      "question": "Een winkel heeft 20% korting gegeven. Je betaalde €80. Wat was de oorspronkelijke prijs?",
      "context": null,
      "options": ["€100", "€96", "€64", "€60"],
      "correctAnswer": 0,
      "conceptId": "reverse_percent_discount",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen na korting",
            "content": "Na 20% korting betaal je 80% van de prijs. Dus 80% = €80. Dan is 100% = €80 ÷ 0,80 = €100. Regel: betaald bedrag ÷ (1 − korting%) = originele prijs."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is €100. Na 20% korting betaal je 80% van de prijs. Dus 80% = €80. Dan is 1% = €80 ÷ 80 = €1. Dan is 100% = €1 × 100 = €100. Of direct: €80 ÷ 0,80 = €100.",
        "distractorExplanations": {
          "0": "Goed! 80% = €80 (na 20% korting). Dan 1% = €1, dus 100% = €100.",
          "1": "€96 is fout. Je hebt misschien €80 + 20% van €80 = €80 + €16 = €96 berekend. Maar je moet terugrekenen: je betaalde 80% van de prijs. 80% = €80, dus 100% = €80 ÷ 0,80 = €100.",
          "2": "€64 is fout. Je hebt misschien €80 − 20% van €80 = €80 − €16 = €64 berekend. Maar je moet terugrekenen naar de originele prijs: 80% = €80, dus 100% = €100.",
          "3": "€60 is fout. Je hebt misschien €80 − €20 = €60 berekend. Maar €20 is niet 20% van de originele prijs. Terugrekenen: 80% = €80, dus 100% = €80 ÷ 0,80 = €100."
        }
      }
    },
    {
      "id": "GET-PROC-TERUG-003",
      "familyId": "GET-PROC-TERUG",
      "module": "Getalbegrip",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_terugrekenen",
      "questionType": "multiple_choice",
      "question": "25% van de leerlingen is 8 leerlingen. Hoeveel leerlingen zijn er in totaal?",
      "context": null,
      "options": ["32", "33", "24", "2"],
      "correctAnswer": 0,
      "conceptId": "reverse_percent_students",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Terugrekenen: kwart naar geheel",
            "content": "25% = ¼. Als ¼ = 8, dan is het geheel = 8 × 4 = 32. Of: 1% = 8 ÷ 25 = 0,32, dan 100% = 0,32 × 100 = 32."
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is 32. Als 25% = 8 leerlingen, dan is 1% = 8 ÷ 25 = 0,32. Dan is 100% = 0,32 × 100 = 32. Of sneller: 25% = ¼, dus het totaal = 8 × 4 = 32.",
        "distractorExplanations": {
          "0": "Goed! 25% = ¼, dus totaal = 8 × 4 = 32. Of: 1% = 8 ÷ 25 = 0,32, dan 100% = 32.",
          "1": "33 is fout. Je hebt misschien 8 × 4 + 1 = 33 berekend. Maar 25% = ¼, dus het totaal = 8 × 4 = 32.",
          "2": "24 is fout. Je hebt misschien 8 × 3 = 24 berekend (75% in plaats van 100%). Maar 25% = ¼, dus het totaal = 8 × 4 = 32.",
          "3": "2 is fout. Je hebt misschien 8 ÷ 4 = 2 berekend (gedeeld in plaats van vermenigvuldigd). Maar 25% = ¼, dus het totaal = 8 × 4 = 32."
        }
      }
    }
  ]
}
